// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ZloR","title":"Info_title__16YE2","links":"Info_links__1pJtD","link":"Info_link__10660","logo":"Info_logo__3Be8P"};